import React from "react";
import Bar from "react-apexcharts";

const BarChart = (props) => {
  return (
    <div id="chart" className="py-2">
      <Bar
        options={props?.options}
        series={props?.series}
        type="bar"
        maxwidth={500}
        height={300}
      />
    </div>
  );
};

export default BarChart;
